var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGigmiSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.07946L9.78722 5.36896C9.55169 5.61265 9.22731 5.75026 8.88841 5.75026H5.75002V8.88865C5.75002 9.22756 5.61241 9.55193 5.36872 9.78746L3.07922 12.0003L5.36872 14.2131C5.61241 14.4486 5.75002 14.773 5.75002 15.1119V18.2503H8.88841C9.22731 18.2503 9.55169 18.3879 9.78722 18.6316L12 20.9211L14.2128 18.6316C14.4483 18.3879 14.7727 18.2503 15.1116 18.2503H18.25V15.1119C18.25 14.773 18.3876 14.4486 18.6313 14.2131L20.9208 12.0003L18.6313 9.78747C18.3876 9.55194 18.25 9.22756 18.25 8.88866V5.75026H15.1116C14.7727 5.75026 14.4483 5.61265 14.2128 5.36896L12 3.07946ZM11.1012 1.85103C11.5926 1.34263 12.4074 1.34263 12.8988 1.85103L15.2177 4.25026H18.5C19.1904 4.25026 19.75 4.80991 19.75 5.50026V8.7826L22.1492 11.1015C22.6576 11.5929 22.6576 12.4077 22.1492 12.8991L19.75 15.218V18.5003C19.75 19.1907 19.1904 19.7503 18.5 19.7503H15.2177L12.8988 22.1495C12.4074 22.6579 11.5926 22.6579 11.1012 22.1495L8.78235 19.7503H5.50002C4.80966 19.7503 4.25002 19.1907 4.25002 18.5003V15.218L1.85079 12.8991C1.34239 12.4077 1.34238 11.5929 1.85079 11.1015L4.25002 8.78259V5.50026C4.25002 4.8099 4.80966 4.25026 5.50002 4.25026H8.78235L11.1012 1.85103Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 12C7.25 9.37665 9.37665 7.25 12 7.25C14.6234 7.25 16.75 9.37665 16.75 12C16.75 14.6234 14.6234 16.75 12 16.75C9.37665 16.75 7.25 14.6234 7.25 12ZM12 8.75C10.2051 8.75 8.75 10.2051 8.75 12C8.75 13.7949 10.2051 15.25 12 15.25C13.7949 15.25 15.25 13.7949 15.25 12C15.25 10.2051 13.7949 8.75 12 8.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGigmiSettings);
export default __webpack_public_path__ + "static/media/gigmiSettings.2dca292a8ce2f4b83f28f66df89cac80.svg";
export { ForwardRef as ReactComponent };